export default __webpack_public_path__ + "images/0xe5417af564e4bfda1c483642db72007871397896.png";